import { render, staticRenderFns } from "./Foldable.vue?vue&type=template&id=3e4c0322"
import script from "./Foldable.vue?vue&type=script&lang=js"
export * from "./Foldable.vue?vue&type=script&lang=js"
import style0 from "./Foldable.vue?vue&type=style&index=0&id=3e4c0322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports